import { duration } from "@/shared/lib";

import { tactileSequence, type TactileStep } from "./tactile";

/**
 * Тактильная фанфара (FE-14) — хореография отклика на завершённое действие.
 *
 * Одиночный `success` честно сообщает «получилось», но ощущается ровно так
 * же, как сохранённый хеш транзакции. Покупка робота — событие, ради
 * которого пользователь пришёл, и она обязана ощущаться крупнее остального.
 *
 * Шаги приклеены к кадрам салюта, а не расставлены на глаз: каждая пауза —
 * токен из шкалы движения. Поэтому фанфару и не заводят отдельно от
 * `<Celebration>`: без картинки она превращается в необъяснимое гудение.
 */
export function fanfareSteps(): TactileStep[] {
  return [
    // Кружок состояния влетает с перелётом (animate-pop-in).
    { at: 0, intent: "tap" },
    // По кольцу расходится волна (animate-ring).
    { at: duration("instant"), intent: "tap" },
    // Разлёт частиц — самый заметный кадр, самый ощутимый удар.
    { at: duration("instant") + duration("fast"), intent: "press" },
    // Подтверждение системы — последним, когда салют уже осыпался, а
    // одометр баланса докатился. Оно и закрывает арку.
    { at: duration("page") + duration("slow"), intent: "success" },
  ];
}

/**
 * Проиграть фанфару.
 *
 * @returns функция отмены — вызывается при уходе экрана, иначе отклик
 * догонит пользователя уже на следующем экране.
 */
export function fanfare(): VoidFunction {
  return tactileSequence(fanfareSteps());
}
